<template>
  <div  >
      
    <MainBanner />
    <div>
      <Gajotsavam/>
    </div>
    <div  >
      <Banner 
      />
    </div> 
    
    <!-- <Quiz /> -->
  </div>
</template>
<script>
import MainBanner from "./mainBanner";
import Banner from "./banner";  
import Gajotsavam from "./gajotsavam";  
export default {
  data() {
    return {
      isActive: false,
      appLoading: false,
      showSnackBar: false,
      timeOut: 5000,
      msg: null, 
    };
  },
  components: {
    MainBanner,
    Banner, 
    Gajotsavam,
  }, 
  beforeMount() {
    // this.getData();
  },
  methods: {
  
  },
};
</script>
